module.exports = __webpack_public_path__ + "img/bendera USA-08-min.9e6e1fdf.png";